// Frontend constants for the multi-specialist collaboration feature.
export const SPECIALTIES = [
  { value: "periodontist", label: "Periodontist" },
  { value: "endodontist", label: "Endodontist" },
  { value: "oral_surgeon", label: "Oral Surgeon" },
  { value: "orthodontist", label: "Orthodontist" },
  { value: "other", label: "Other" },
];

export const STATUS_STYLE = {
  pending: { label: "Pending", color: "text-amber-300", dot: "bg-amber-400" },
  submitted: { label: "Submitted", color: "text-emerald-300", dot: "bg-emerald-400" },
  revoked: { label: "Revoked", color: "text-red-300", dot: "bg-red-400" },
  expired: { label: "Expired", color: "text-[var(--pa-text-dim)]", dot: "bg-zinc-500" },
};

export const CASE_STATUS_STYLE = {
  pending: { label: "Awaiting specialists", color: "text-amber-300" },
  in_review: { label: "Specialist input received", color: "text-sky-300" },
  synthesized: { label: "Synthesized — ready for GP review", color: "text-[var(--pa-gold)]" },
  acknowledged: { label: "Acknowledged & finalized", color: "text-emerald-300" },
};

export function buildPortalUrl(token) {
  return `${window.location.origin}/collab/portal/${token}`;
}
